export default __webpack_public_path__ + "static/media/money_bag_3d.c9433e43.png";